import SimplePage from "../components/site/SimplePage";

const sections = [
  {
    title: "Our Mission",
    text: "We work with local leaders to expand education access, health services, and safe livelihoods for families in need."
  },
  {
    title: "Our Vision",
    text: "A future where every community has the resources and support to thrive with dignity."
  },
  {
    title: "Our History",
    text: "Founded in 2012, Hope Foundation has grown from a neighborhood tutoring group into a multi-state NGO serving thousands each year."
  }
];

function About() {
  return (
    <SimplePage
      title="About Us"
      lead="Hope Foundation is built on community-led change, measurable impact, and long-term partnerships."
      sections={sections}
    />
  );
}

export default About;
